export default __webpack_public_path__ + "static/media/mb-cta-analytics.e7f8a5bc.svg";